import { Injectable } from '@angular/core';
import {BaseService} from './base.service';
import {SERVICE_URLS} from '../enums';
import { HttpClient } from '@angular/common/http';
import { RequestModel } from '../models';
import { AppConfig } from '../_config'
@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  constructor(private appConfig: AppConfig,private baseService: BaseService,private _http: HttpClient) { }

  readApplication(searchRequest) {
    return this.baseService.Request(SERVICE_URLS.GET_APPLICATION_BY_CNIC,searchRequest);
   }
   GetOTP(searchRequest) {
    searchRequest["TemplateId"] = this.appConfig.OTACTemplateId; //'3182';
    return this.baseService.Request(SERVICE_URLS.GET_OTP,searchRequest);
   }
   VerifyOTP(searchRequest) {
    return this.baseService.Request(SERVICE_URLS.VERIFY_OTP,searchRequest);
   }
   readApplicationById(appId) {
    return this.baseService.Request(SERVICE_URLS.GET_APPLICATION_BY_ID,[{'key':appId}]);
   }
   readApplicationByAccountNumber(accountNum) {
    return this.baseService.Request(SERVICE_URLS.GET_APPLICATION_BY_ACCOUNT,[{'key':accountNum}]);
   }
   postApplication(accountApplicationVM) {
    return this.baseService.Request(SERVICE_URLS.CREATE_APPLICATION,accountApplicationVM);
   }
   updateApplication(accountApplicationVM) {
    return this.baseService.Request(SERVICE_URLS.UPDATE_APP,accountApplicationVM);
   }
   initiateWF(accountApplicationVM) {
    return this.baseService.Request(SERVICE_URLS.INITIATE_WF,accountApplicationVM);
   }
  //  postApplication(accountApplicationVM){
  //   return this._http.post('http://localhost:27257/api/v1/CustomerAccountOpening',accountApplicationVM);
  // }
}
